module.exports = __webpack_public_path__ + "static/feature wall-02549dc552b3ea3faed7f3a6fb937895.jpg";